import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';

import { PrescriptionTemplate } from '../prescription-template';

@Component({
  selector: 'mc-prescription-template-form',
  templateUrl: './prescription-template-form.component.html',
  styleUrls: ['./prescription-template-form.component.scss']
})
export class PrescriptionTemplateFormComponent implements OnInit {

  @Input() template: PrescriptionTemplate;
  @Output() canceled: EventEmitter<boolean> = new EventEmitter<boolean>();
  @Output() saved: EventEmitter<PrescriptionTemplate> = new EventEmitter<PrescriptionTemplate>();

  constructor() { }

  ngOnInit() {
  }

  save(): void {
    this.saved.emit(this.template);
  }

  cancel(): void {
    this.canceled.emit(true);
  }
}
